module.exports = JSON.parse("{\"timestamp\":\"20.09.2026 - 22:41:34\",\"brands\":[]}")